<div class="container padding__basic">

    <form [formGroup]="form" target="_blank" class="form" id="influencers_form" name="influencers_form"
        (ngSubmit)="onSubmit()">
        <div class="container">
            <div fxLayout="row" fxLayoutGap="4%">
                <div fxFlex="100">
                    <div class="margin__top--xs container">
                        <p class="margin__bottom-xxs"><strong><small>Temática:</small></strong></p>
                        <mat-form-field appearance="fill">
                            <mat-label>Tipo</mat-label>
                            <mat-select formControlName="tematica">
                                <mat-option *ngFor="let option of options" [value]="option.value">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

            </div>
        </div>
    </form>
</div>